import React, { useEffect, useState } from 'react';
import anime from 'animejs';
import { ThemeProvider, createTheme, Dialog } from "@mui/material";
import './style.css';
import Footer from '../../Components/Footer';
import ScrollToTop from '../../Components/scrollup';
import HomeIcon from '@mui/icons-material/Home';


const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
  palette: {
    primary: {
      main: '#00897b',
      light: '#80cbc4',
      dark: '#00695c',
      contrastText: '#fff',
    },
  },
});

export default function Promo() {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    anime({
      targets: ".PromoImg",
      translateX: [-400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(200, { start: 300 }),
      easing: "easeInOutQuad",
    });
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".PromoImg:not(.vide)");
    anime({
      targets: elements,
      translateX: [-400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(300, { start: 400 }),
      easing: "easeInOutQuad",
    });
  }, []);

  const handleOpenDialog = (img) => {
    console.log('Image clicked:', img);  // Ajoutons un log pour vérifier
    setSelectedImage(img);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedImage(null);
  };

  return (
    <ThemeProvider theme={customTheme}>
      <div className='blog'>
        <ScrollToTop />
        <div className='blogHead'>
          <h1>العروض</h1>
          <div>
            <a href="/">
              <HomeIcon fontSize="small" /> <h5>الرئيسية</h5>
            </a>
          </div>
        </div>
        <h2 className='albumTitle'>! استمتع بمجموعة من العروض الخاصة المصممة خصيصًا لك! دعنا نساعدك على الاسترخاء وتجديد شبابك</h2>
        <div className='refGrid'>
          
          {album.map((item) => (
             <div
             className="linkItems"
           >
            <div className={`image-zoom-containe`} key={item.img}>
              <img
                src={require(`../../Images/promo/${item.img}.jpg`)}
                alt={item.img}
                className='PromoImg'
                onClick={() => handleOpenDialog(item.img)} 
              />
            </div>
            <span>{item.descreption}</span>
            </div>
          ))}
        </div>

        {/* Dialog pour afficher l'image sélectionnée */}
        <Dialog open={openDialog} onClose={handleCloseDialog} style={{zIndex:99999}}>
         
         
            {selectedImage && (
              <img
                src={require(`../../Images/promo/${selectedImage}.jpg`)}
                alt={selectedImage}
              />
            )}
       
        </Dialog>

        <Footer />
      </div>
    </ThemeProvider>
  );
}

const album = [
  { img: "1" },
  { img: "2" },
  { img: "3" },
  { img: "4" },
  { img: "5" },
];
